// TODO add common translation keys here so code completion can be used
export const T_COMMON = {
	ACTIONS: "COMMON.ACTIONS",
	TYPE: "COMMON_TYPE",
	FROM: "COMMON_FROM",
	UNTIL: "COMMON_UNTIL",
	DESCRIPTION: "COMMON.DESCRIPTION",
	UNIQUE_FORM_ERROR: "COMMON_UNIQUE_FORM_ERROR",
	NO_DATA: "COMMON.NO_DATA_LABEL",
	CLOSE: "CLOSE",
	OK: "COMMON_OK",
	CANCEL: "COMMON_CANCEL",
	TIME_PLACEHOLDER: "COMMON.TIME_PLACEHOLDER",
	ID: "COMMON.ID",
	PRINT: "COMMON.PRINT",
	CONFIRM_SAVE_TITLE: "COMMON.CONFIRM_SAVE_MODAL.TITLE",
	CONFIRM_SAVE_TEXT: "COMMON.CONFIRM_SAVE_MODAL.TEXT",
	CONFIRM_DELETE_TITLE: "COMMON.CONFIRM_DELETE_MODAL.TITLE",
	CONFIRM_DELETE_TEXT: "COMMON.CONFIRM_DELETE_MODAL.TEXT",
	DETAILS: "COMMON.DETAILS",
	NEW: "NEW",
	SAVE: "SAVE",
	DELETE: "DELETE",
	DISCARD: "DISCARD",
	COPY: "COMMON.COPY",
	NAME: "COMMON.NAME",
	STAFF_UNIT: "COMMON.STAFF_UNIT",
	STAFF_MEMBER_ID: "COMMON.STAFF_MEMBER_ID",
	STAFF_MEMBER_NAME: "COMMON.STAFF_MEMBER_NAME",
	STAFF_MEMBER: "COMMON.COL.STAFF_MEMBER",
	DATE: "COMMON.DATE",
	ABBR_NOT_AVAILABLE: "COMMON.ABBR.NOT_AVAILABLE",
	PRIORITY: "COMMON.PRIORITY",
	REMOVE: "COMMON_REMOVE",
	SORT_ORDER: "COMMON.SORT_ORDER",
} as const;
